import type { FeedItem } from "@compass/shared/schema/api/feed";
import { useNavigate } from "@tanstack/react-router";
import { CheckCircle, ShoppingBag } from "lucide-react";
import { FavoriteButton } from "components/elements/FavoriteButton";

type Props = Extract<FeedItem, { type: "vendorApproved" }>;

export const FeedVendorCard = ({ vendor }: Props) => {
    const navigate = useNavigate();

    return (
        <div
            role="link"
            tabIndex={0}
            onClick={() => navigate({ to: "/vendors/$id", params: { id: String(vendor.id) } })}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    navigate({ to: "/vendors/$id", params: { id: String(vendor.id) } });
                }
            }}
            className="cursor-pointer rounded-2xl border border-green-200 bg-white p-4 shadow-sm transition-shadow hover:shadow-md"
        >
            <div className="mb-2 flex items-center justify-between">
                <div className="flex items-center gap-1.5">
                    <ShoppingBag className="h-4 w-4 text-green-600" />
                    <span className="flex items-center gap-1 rounded-full bg-green-100 px-2 py-0.5 text-[10px] font-medium text-green-700">
                        <CheckCircle className="h-3 w-3" />
                        Approved Vendor
                    </span>
                </div>
                <FavoriteButton target={{ type: "vendor", id: vendor.id }} size={16} />
            </div>
            <h3 className="text-base font-semibold text-gray-900">{vendor.name}</h3>
            <div className="mt-2 flex items-center gap-2">
                {vendor.category && (
                    <span className="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-600">
                        {vendor.category}
                    </span>
                )}
                <a
                    href={vendor.website}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-xs text-blue-500 hover:underline"
                    onClick={(e) => e.stopPropagation()}
                >
                    {vendor.website.replace(/^https?:\/\//, "").replace(/\/$/, "")}
                </a>
            </div>
        </div>
    );
};
